import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, title, content, buttonText, onButtonClick }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <p className="modal-text">{content}</p>
        <button className="modal-button" onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default Modal; 